import { AppLogo } from "@/components/AppLogo";
import { Menu } from "lucide-react";
import { cn } from "@/lib/utils";

interface HeaderProps {
  onMenuClick: () => void;
  sidebarOpen: boolean;
}

const Header = ({ onMenuClick, sidebarOpen }: HeaderProps) => {
  return (
    <header
      className={cn(
        "lg:hidden bg-white border-b border-gray-200 min-h-16 flex items-center justify-between gap-3 px-4 py-2 fixed top-0 left-0 right-0 z-50 transition-transform duration-300 ease-in-out",
        sidebarOpen && "-translate-y-full" // Cache le header quand sidebar ouverte
      )}
    >
      {/* Logo à gauche */}
      <div className="flex min-w-0 flex-col items-start gap-0.5">
        <div className="flex items-center gap-2">
          <AppLogo size="sm" className="shrink-0" />
          <h1 className="font-display text-lg font-normal leading-tight text-gray-900">
            Pointo
          </h1>
        </div>
        <p className="pl-[2.5rem] text-xs text-gray-500">Espace administrateur</p>
      </div>

      {/* Menu hamburger à droite */}
      <button
        onClick={onMenuClick}
        className="p-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
      >
        <Menu className="h-6 w-6" />
      </button>
    </header>
  );
};

export default Header;
